<template>
</template>
<script>
export default {
	data() {
		return {
		};
	},
	mounted() {
		
	},
	methods: {
		
	},
  computed: {
  },
	watch: {
	},
	components: {},
	computed: {
	},
  updated (){},
  created() {}
};
</script>
<style>
	
</style>

